import { FieldArrayPath, FieldValues, useFieldArray } from 'react-hook-form'
import { BaseProps } from '../FieldControl'
import { ArrayFieldProvider, ArrayFieldProviderProps } from './ArrayFieldContext'

export type ArrayFieldContainerProps<
  TFieldValues extends FieldValues = FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues> = FieldArrayPath<TFieldValues>,
  TKeyName extends string = 'id',
> = Pick<
  ArrayFieldProviderProps<TFieldValues, TFieldArrayName, TKeyName>,
  'defaultValue' | 'max' | 'min' | 'name'
> &
  Pick<BaseProps<TFieldValues>, 'control' | 'children'>

export function ArrayFieldContainer<
  TFieldValues extends FieldValues = FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues> = FieldArrayPath<TFieldValues>,
  TKeyName extends string = 'id',
>({
  defaultValue,
  control,
  min,
  max,
  name,
  children,
}: ArrayFieldContainerProps<TFieldValues, TFieldArrayName, TKeyName>) {
  const fieldArray = useFieldArray<TFieldValues, TFieldArrayName, TKeyName>({
    control,
    name: name,
  })

  return (
    <ArrayFieldProvider<TFieldValues, TFieldArrayName, TKeyName>
      defaultValue={defaultValue}
      fieldArray={fieldArray}
      max={max}
      min={min}
      name={name}
    >
      {children}
    </ArrayFieldProvider>
  )
}

export type ArrayFieldContainerComponent<
  TFieldValues extends FieldValues = FieldValues,
  TFieldArrayName extends FieldArrayPath<TFieldValues> = FieldArrayPath<TFieldValues>,
  TKeyName extends string = 'id',
> = typeof ArrayFieldContainer<TFieldValues, TFieldArrayName, TKeyName>
